import { LensStatus } from "../../../gql-generated";

export const lensStatusLabelMap: Record<string, { text: string }> = {
    [LensStatus.LensStatusInReview]: { text: "Processing" },
    [LensStatus.LensStatusInvalid]: { text: "Invalid" },
    [LensStatus.LensStatusRejected]: { text: "Rejected" },
    [LensStatus.LensStatusLive]: { text: "Available" },
    [LensStatus.LensStatusOffline]: { text: "Offline" },
    [LensStatus.LensStatusNotPublishedToSnapchat]: { text: "Available" },
    [LensStatus.LensStatusHidden]: { text: "Available" },
    [LensStatus.LensStatusProcessing]: { text: "Processing" },
    [LensStatus.LensStatusAvailable]: { text: "Available" },
};
